import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './Checkbox.module.scss';

export interface NebiCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Rótulo visível ao lado da caixa. Sem ele, passe `aria-label`. */
  label?: string;
  /** Cai no wrapper, não no `<input>` — mesma convenção de `Input` e `Select`. */
  className?: string;
}

/**
 * `<input type="checkbox">` cru não lê token nenhum: pinta com o `accent-color`
 * do navegador e fica ilegível sob o tema Noturno. Este primitivo amarra a cor
 * ao `--nebi-accent` e garante foco visível nos dois temas.
 */
export const Checkbox = forwardRef<HTMLInputElement, NebiCheckboxProps>(function Checkbox(
  { label, className, id, disabled, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? `nebi-checkbox-${autoId}`;

  return (
    <div className={clsx(styles.wrapper, disabled && styles.disabled, className)}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className={styles.input}
        disabled={disabled}
        {...rest}
      />
      {label && (
        <label className={styles.label} htmlFor={inputId}>
          {label}
        </label>
      )}
    </div>
  );
});

export default Checkbox;
